module.exports = __webpack_public_path__ + "img/arrows.186ff242.svg";